import React from "react";
import { Img } from "../Img/index";

const TestimonialsActionCard = ({ element, handleOpenDrawer, onDelete, isError }: any) => {
  const testimonialText = element.TESTIMONIALS_TESTIMONIAL || "";

  return (
    <div
      className={`bg-white rounded-lg shadow-lg ${isError ? "shadow-red-500" : ""} py-1 px-3 h-full w-full flex flex-col`}
      style={{ fontFamily: "'Manrope', sans-serif" }}
    >
      {/* Header Section with Avatar, Name, and Action Buttons */}
      <div className="flex items-center gap-2">
        {element?.TESTIMONIALS_IMAGE?.selectedImage ? (
          <Img
            src={element.TESTIMONIALS_IMAGE.selectedImage}
            className="w-[6vh] h-[6vh] rounded-full"
          />
        ) : (
          <div className="w-[6vh] h-[6vh] bg-gray-200 rounded-full flex items-center justify-center">
            <span className="text-gray-500 font-medium">
              {element.TESTIMONIALS_NAME ? element.TESTIMONIALS_NAME.charAt(0) : ""}
            </span>
          </div>
        )}

        <div className="flex-1">
          <p
            className="font-medium text-gray-900 text-[2vh] truncate"
            style={{ maxWidth: "20ch" }}
            title={element.TESTIMONIALS_NAME}
          >
            {element.TESTIMONIALS_NAME}
          </p>
          <p className="text-gray-500 text-[1.8vh]">
            {element.TESTIMONIALS_DESIGNATION ? element.TESTIMONIALS_DESIGNATION : ""}
          </p>
        </div>

        <div className="flex space-x-2">
          {!!handleOpenDrawer && <button
            onClick={handleOpenDrawer}
            className="text-gray-500 hover:text-blue-600"
            type="button"
          >
            <img src="/images/edit-3.svg" alt="edit" className="w-[2.7vh] h-[2.7vh]" />
          </button>}
          {!!onDelete && <button
            onClick={onDelete}
            className="text-gray-500 hover:text-red-600"
            type="button"
          >
            <img src="/images/trash.svg" alt="trash" className="w-[2.7vh] h-[2.7vh]" />
          </button>}
        </div>
      </div>

      <hr className="w-full my-1 border-gray-200" />

      {/* Details Section with the Full Testimonial Description */}
      <div className="space-y-0.5 text-[1.8vh] mt-1 flex-grow leading-relaxed">
        <div className="flex flex-col mt-1">
          <span
            className="font-medium text-gray-800"
            title={testimonialText}
          >
            {testimonialText}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsActionCard;